module.exports = __webpack_public_path__ + "static/media/monitoring2.160bb821.png";